import { FC, useEffect, useMemo, useRef } from "react"
import { Wrapper, SortingItem } from "./styles"
import { useTranslation } from "react-i18next"
import useQueryState from "shared/hooks/useQueryState";
import { modalControllerSelector, useModal } from "core";
import { useSelector } from "react-redux";


export const SortingModal: FC<{ sortingItems: number[] }> = ({ sortingItems }) => {
    const { t } = useTranslation();
    const modal = useModal();
    const sortingRef = useRef<HTMLDivElement>(null);
    const [ { sorting }, setQueryParams] = useQueryState();

    const currentSorting = useMemo(
        () => (!sorting ? sortingItems?.[0] : sorting) , [sorting, sortingItems])

    const isModalOpen = useSelector(modalControllerSelector)?.name

    const onSortingClick = (ev: React.SyntheticEvent) => {
        //@ts-ignore
        setQueryParams({ sorting: Number(ev.target?.['dataset']?.key) })
        modal.hide();
    }

    const handleClose = (ev: any) => {
        if (isModalOpen !== 'sorting-modal') {
            return;
        }
        if (sortingRef.current && !sortingRef.current?.contains(ev.target)) {
            modal.hide();
        }
    }
    

    const itemName = (k: number) => 
        t(`sorting_type.${Number(k) === 1 ? 'latest' : 'popular' }`).toLowerCase()

    useEffect(() => {
        window.addEventListener('click', handleClose)

        return () => {
            window.removeEventListener('click', handleClose)
        }
    }, [])

    return (
        <Wrapper ref={sortingRef} className={'sorting-modal-wrapper js-sorting-modal-wrapper'}>
            {sortingItems?.map((item) => {
                return (
                    <SortingItem 
                        isActive={Number(currentSorting) === item} 
                        onClick={onSortingClick} 
                        data-key={item} 
                        key={item}
                        >
                        {itemName(item)}
                    </SortingItem>
                )
            })}
        </Wrapper>
    )
}import { FC, useEffect, useMemo, useRef } from "react"
import { Wrapper, SortingItem } from "./styles"
import { useTranslation } from "react-i18next"
import useQueryState from "shared/hooks/useQueryState";
import { modalControllerSelector, useModal } from "core";
import { useSelector } from "react-redux";


export const SortingModal: FC<{ sortingItems: number[] }> = ({ sortingItems }) => {
    const { t } = useTranslation();
    const modal = useModal();
    const sortingRef = useRef<HTMLDivElement>(null);
    const [ { sorting }, setQueryParams] = useQueryState();

    const currentSorting = useMemo(
        () => (!sorting ? sortingItems?.[0] : sorting) , [sorting, sortingItems])

    const isModalOpen = useSelector(modalControllerSelector)?.name

    const onSortingClick = (ev: React.SyntheticEvent) => {
        //@ts-ignore
        setQueryParams({ sorting: Number(ev.target?.['dataset']?.key) })
        modal.hide();
    }

    const handleClose = (ev: any) => {
        if (isModalOpen !== 'sorting-modal') {
            return;
        }
        if (sortingRef.current && !sortingRef.current?.contains(ev.target)) {
            modal.hide();
        }
    }
    

    const itemName = (k: number) => 
        t(`sorting_type.${Number(k) === 1 ? 'latest' : 'popular' }`).toLowerCase()

    useEffect(() => {
        window.addEventListener('click', handleClose)

        return () => {
            window.removeEventListener('click', handleClose)
        }
    }, [])

    return (
        <Wrapper ref={sortingRef} className={'sorting-modal-wrapper js-sorting-modal-wrapper'}>
            {sortingItems?.map((item) => {
                return (
                    <SortingItem 
                        isActive={Number(currentSorting) === item} 
                        onClick={onSortingClick} 
                        data-key={item} 
                        key={item}
                        >
                        {itemName(item)}
                    </SortingItem>
                )
            })}
        </Wrapper>
    )
}